import PageContainer from "../components/layouts/PageContainer";
import PageHeader from "../components/shared/PageHeader";
import PageOuterContainer from "../components/layouts/PageOuterContainer";
import Head from "next/head";
import seo from "../constants/seo.json";
import Box from "@mui/material/Box";
import styles from "../styles/Features.module.css";
import {
    Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from "@mui/material";
import FeatureCardItem from "../components/shared/FeatureCardItem";
import FeatureLargeItem from "../components/shared/FeatureLargeItem";


const features = [{
    image: '/images/emergency-groups.png',
    subject: 'Emergency specific groups',
    primaryText: 'Set-up via Web Portal. Use a CSV file to upload and create multiple groups quickly. Sync your groups via LDAP based Active Directory.',
    secondaryText: 'Pre-planned group members may belong to different organizations (Fire, Police, EMS etc.).',
    direction: 'left'
}, {
    image: '/images/flow-animation-image.png',
    subject: 'Blast Dial capability',
    primaryText: 'Trigger the dial-out based on incoming phone call, click on a Web Portal, closure of a relay, (optional) or at a scheduled time.',
    secondaryText: 'Multiple first responders are called in parallel - reduces the overall time required to contact them.',
    direction: 'right'
}, {
    image: '/images/find-you-capability.png',
    subject: 'Find-me capability',
    primaryText: 'System dials up to 4 phone numbers and sends SMS and emails when locating an individual recipient. Improves the probability of reaching an individual first responder.',
    secondaryText: '',
    direction: 'left'
}, {
    image: '/images/secure-conference.png',
    subject: 'Secure audio conferencing',
    primaryText: 'Allow First Responders to join the conference only after they enter a security key.',
    secondaryText: 'Prevents unauthorized participants to enter an emergency conference.',
    direction: 'right'
}, {
    image: '/images/call-log.png',
    subject: 'Call logging',
    primaryText: 'Record all InstaConference calls and capture call logs with time stamps.',
    secondaryText: 'Useful for post-event analysis.',
    direction: 'left'
}, {
    image: '/images/send-sms-emails.png',
    subject: 'Send SMS, Email and Pager messages',
    primaryText: 'Set-up via Web Portal. Send SMS, Email and Pager blasts with or without accompanying voice calls. Helps in disseminating emergency related information in multiple ways.',
    secondaryText: '',
    direction: 'right'
}]


export default function Features() {
    const meta = seo.features;
    return (<PageOuterContainer>
        <Head>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description}/>
            <meta name="keywords" content={meta.keywords}/>
        </Head>
        <PageContainer>
            <PageHeader text="Features"/>

            <Box className={styles.container}>

                <Box display={"flex"} justifyContent={"center"} flexDirection={"row"} flexWrap={"wrap"} mt={3}
                     mb={3}>
                    <FeatureCardItem
                        text={"Send calls to any landline or cellular phone."}
                        image={"/images/flexible-emergency-calling.png"}
                        name={"Flexible Calling"}
                    />

                    <FeatureCardItem
                        text={"Select communication medium to be used for message delivery (Voice only, SMS only, Email only or any combination of the above.)"}
                        image={"/images/message-channels.png"}
                        name={"Message Channels"}
                    />

                    <FeatureCardItem
                        text={"Use built-in ’Find-me’ capability to increase the probability of finding a recipient."}
                        image={"/images/location-tracking.png"}
                        name={"Find Me"}
                    />

                    <FeatureCardItem
                        text={"Send Caller-ID of your choice that can be used by cell phones to display associated caller name (e.g., 'Fire Chief') - leading to higher percentage of recipients picking up the phone."}
                        image={"/images/caller-id.png"}
                        name={"Caller ID Optimization"}
                    />
                </Box>

                {features.map((feature, index) => {
                    return (<FeatureLargeItem
                        key={index}
                        image={feature.image}
                        subject={feature.subject}
                        primaryText={feature.primaryText}
                        secondaryText={feature.secondaryText}
                        direction={feature.direction}
                    />)
                })}

            </Box>
        </PageContainer>
    </PageOuterContainer>)
}
